import { render, staticRenderFns } from "./FileComponent.vue?vue&type=template&id=ea6f1d86&scoped=true&"
import script from "./FileComponent.vue?vue&type=script&lang=js&"
export * from "./FileComponent.vue?vue&type=script&lang=js&"
import style0 from "./FileComponent.vue?vue&type=style&index=0&id=ea6f1d86&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6f1d86",
  null
  
)

export default component.exports